import Cart from "../models/Cart";
import CartItem from "../models/CartItem";
import CartService from "../models/CartService";

const CART_ITEM_SCHEMA: CartItem = {
  code: '',
  number: '',
  version: 0,
  totalDue: 0,
  totalPaid: 0,
  totalPending: 0,
  remainDue: 0,
  weight: 0,
  pieces: 0,
  added_weight: 0,
  added_pieces: 0,
  arrival_date: '',
  parts: [],
  services: [],
  allowedServices: {
    breakdown_hawb: false,
    bup_ld3: false,
    bup_ld7: false,
    bup_q7: false,
    bup_20ft: false,
    label_freight: false,
    bup_main_deck: false,
    per_hawb: false,
    per_hawb_exclude_import_service: false,
    reicing: false,
    storage_fee: false,
    customs_fee: false,
    other: false,
    gha_adjust: false,
    perishable_storage: false,
    cage_vault: false,
    skid_exch: false,
    comat: false,
    copa_comat: false,
    nomination_fee: false,
    certified_manifest_charge: false
  }
};

function findCartItemByCodeAndNumber(awbCode: string, awbNumber: string, cart: Cart): CartItem | undefined {

  return cart.items.find((cartItem: CartItem) => {
    return cartItem.code === awbCode && cartItem.number === awbNumber;
  });
}

function findCartItemService(cartItem: CartItem, rawServiceName: string, reason?: string): CartService | undefined {

  return cartItem.services.find((service: CartService) => 
    (service.type !== 'other'  && service.type !== 'gha_adjust' && service.type === rawServiceName) ||
    ((service.type === 'other' ||  service.type === 'gha_adjust') && service.params.reason === reason ));
}

export {
  CART_ITEM_SCHEMA,
  findCartItemByCodeAndNumber,
  findCartItemService
}